// eslint-disable-next-line func-names
(function () {
    function $stringExtender(str) {
        function capitalize() {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
        function unCapitalize() {
            return str.charAt(0).toLowerCase() + str.slice(1);
        }
        function latinize() {
            return str
                .split('')
                .map((letter) => {
                    const accents = 'ÀÁÂÃÄÅĄĀāàáâãäåąßÒÓÔÕÕÖØŐòóôőõöøĎďDŽdžÈÉÊËĘèéêëęðÇçČčĆćÐÌÍÎÏĪìíîïīÙÚÛÜŰùűúûüĽĹŁľĺłÑŇŃňñńŔŕŠŚŞšśşŤťŸÝÿýŽŻŹžżźđĢĞģğ';
                    const out = 'AAAAAAAAaaaaaaaasOOOOOOOOoooooooDdDZdzEEEEEeeeeeeCcCcCcDIIIIIiiiiiUUUUUuuuuuLLLlllNNNnnnRrSSSsssTtYYyyZZZzzzdGGgg';
                    const i = accents.indexOf(letter);
                    return i !== -1 ? out[i] : letter;
                })
                .join('');
        }
        function containsOnlyDigitsAndDots() {
            return /^[0-9.\r\n ]*$/.test(str);
        }
        function startsWith(search, rawPos) {
            // eslint-disable-next-line no-bitwise
            const pos = rawPos > 0 ? rawPos | 0 : 0;
            return str.substring(pos, pos + search.length) === search;
        }
        function stripFromHTML() {
            return str.replace(/(<([^>]+)>)/ig, '');
        }
        function toHTML() {
            const tempHTML = document.createElement('div');
            tempHTML.innerHTML = str;
            return tempHTML.firstChild;
        }
        function isEmpty() {
            return str.trim().length === 0;
        }
        function contains(pattern) {
            return str.indexOf(pattern) !== -1;
        }
        return {
            capitalize,
            unCapitalize,
            latinize,
            containsOnlyDigitsAndDots,
            startsWith,
            stripFromHTML,
            toHTML,
            isEmpty,
            contains
        };
    }

    // eslint-disable-next-line no-extend-native
    Object.defineProperty(String.prototype, 'extensions', {
        set() {},
        get() {
            return $stringExtender(this);
        }
    });
}());